import { Link } from "react-router-dom";
import documentIcon from "../../assets/images/icons/document-outline.svg";

export default function Dashboard() {
    return (
        <div className="grid mt-8 w-full max-w-5xl place-items-center">
            <div className="flex flex-col gap-8">
                <h1 className="text-center text-4xl font-bold">Dashboard</h1>
                <div>
                    <p>
                        Seja bem-vindo a sua Dashboard. Daqui você tem o poder de controlar
                        o seu site por completo.
                    </p>
                    <p>
                        Clique em um dos links abaixo para ser redirecionado à
                        sessão correspondente.
                    </p>
                </div>
                <ul>
                    <li>
                        <Link
                            className={
                                "flex items-center gap-1 border border-xv-border-color p-4 odd:bg-xv-bg-2 hocus:brightness-90 hocus:bg-xv-bg-1"
                            }
                            to="/dashboard/posts"
                        >
                            <img
                                className="w-6"
                                src={documentIcon}
                                alt="Ícone de documentos"
                            />
                            <span>Posts</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}
